import { z } from 'zod';

import { BankruptcyCh13AgreedOrder } from '../../../loan/WorkoutPlan';
import { BaseLoanEvent } from '../../BaseLoanEvent';

/**
 * Records a court-ordered agreed order on the active Chapter 13 plan's post-petition side. Any
 * active agreed order covering an overlapping statement window is cancelled as part of applying
 * this one — only one active agreed order may cover a given post-petition installment.
 */
export const CreateBankruptcyCh13AgreedOrderEvent = BaseLoanEvent.extend({
  type: z.literal('createBankruptcyCh13AgreedOrder'),
  data: BankruptcyCh13AgreedOrder.omit({ id: true, cancelledDate: true, createdAt: true }),
});
export type CreateBankruptcyCh13AgreedOrderEvent = z.infer<typeof CreateBankruptcyCh13AgreedOrderEvent>;
